export const SITE_NAME = 'PrinterHelps';
export const SITE_DOMAIN = 'printerhelps.store';
export const SITE_URL = 'https://printerhelps.store';
export const COMPANY_NAME = 'PrinterHelps';
export const POLICY_UPDATED = '26 August 2026';

/** Lead Desk — form posts here */
export const LEAD_API_URL = 'https://lead.dzdstech.com/api/v1/leads';
export const LEAD_API_KEY = 'lms_f8e492fdb85da15edb80bf1e40ecfc566c2077f681825714';
